import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { trackEvents } from "app/components/ChangeSolutionModal/hooks/utils";
import { USE_CASE_STEP_CONFIG } from "app/components/ChangeSolutionModal/config/changeSolutionSteps";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { useTranslation } from "pro-features/components/WithTranslation";

import {
    TileStyled,
    UseCaseContainer,
    Title,
    TileContainer,
    StyledScreenWrapper,
    StyledScreenTitle,
    StyledScreenDescription,
    DefaultTile,
} from "../../styles";
import type { IUseCaseStepConfig, IStepScreenProps, UseCaseGroupKey } from "../../types";

interface ISolutionSelectionStep extends IStepScreenProps {
    selectedSolution?: IUseCaseStepConfig;
    defaultSolution: IUseCaseStepConfig | null;
    onSelectedSolutionChange: (selection: IUseCaseStepConfig) => void;
}

const { carbon, blue } = colorsPalettes;

export const SolutionSelectionStep = ({
    selectedSolution,
    onSelectedSolutionChange,
    defaultSolution,
    config,
}: ISolutionSelectionStep) => {
    const translate = useTranslation();
    const handleGoalSelect = (solution: IUseCaseStepConfig) => {
        trackEvents("choose", `${config.trackingEventName}/${solution.value}`);
        onSelectedSolutionChange({ ...solution });
    };

    return (
        <StyledScreenWrapper>
            <StyledScreenTitle
                fontVariant="h3"
                color={carbon[500]}
            >
                {translate(config.title)}
            </StyledScreenTitle>

            <StyledScreenDescription
                fontVariant="h6"
                color={carbon[400]}
            >
                <I18n dangerouslySetInnerHTML>{translate(config.subTitle)}</I18n>
            </StyledScreenDescription>
            <UseCaseContainer>
                {(Object.keys(USE_CASE_STEP_CONFIG) as UseCaseGroupKey[]).map((useCaseKey) => {
                    const solution = USE_CASE_STEP_CONFIG[useCaseKey];
                    const isSelected = solution.value === selectedSolution?.value;

                    return (
                        <TileStyled
                            key={useCaseKey}
                            isSelected={isSelected}
                            onClick={() => handleGoalSelect(solution)}
                        >
                            {defaultSolution?.value === solution.value ? (
                                <DefaultTile>
                                    {translate(
                                        "components.shared.change_solution_modal.solution_selection.original_goal",
                                    )}
                                </DefaultTile>
                            ) : null}
                            <TileContainer data-automation={solution.value}>
                                <Title>
                                    <Text
                                        fontVariant="report"
                                        color={carbon[500]}
                                    >
                                        {translate(solution.title)}
                                    </Text>
                                </Title>
                            </TileContainer>
                        </TileStyled>
                    );
                })}
            </UseCaseContainer>
        </StyledScreenWrapper>
    );
};
